import AuctionsList from "./AuctionsList";

export default AuctionsList;
